<template>
  <div>
    <div class="text-center" v-if="medicines.length == 0">0</div>
    <div
      v-for="(medicine, key) in medicines"
      :key="key"
      class="content-medicine border-bottom"
    >
      <div class="row">
        <div
          class="
            col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12
            check-text-center
            pt-0
            pb-0
          "
        >
          <h6 class="mb-0">
            {{ medicine.medicine_name }}
          </h6>
          <p class="legends worksansr mb-0">
            {{ medicine.medicine_active_ingredient }}
          </p>
          <h6
            class="btn-pendent mb-1 center-text inline-display"
            v-if="medicine.type_of_recipe_name == 'CONTROLE ESPECIAL - 2 VIAS'"
          >
            CONTROLE ESPECIAL
          </h6>
          <br
            v-if="
              medicine.group_prescription_medicine_type == 'LONGO_PRAZO' &&
              medicine.medicine_list
            "
          />
          <h6
            class="color-edit text-twelve inline-display mb-1"
            v-if="medicine.group_prescription_medicine_type == 'LONGO_PRAZO'"
          >
            MEDICAMENTO DE PRESCRIÇÃO DE LONGO PRAZO!
          </h6>
          <p class="m-0 legends" v-if="medicine.lot_total">
            TOTAL NO ESTOQUE:
            {{ medicine.lot_total }}
            {{ medicine.unit_of_measurement_abbreviation }}
          </p>
          <h6
            v-if="medicine.frequency != 'EVENTUAL'"
            class="m-0 legends worksansr"
          >
            USO:
            {{ handleDuration(medicine.duration) }}
          </h6>
          <h6
            v-if="medicine.frequency == 'EVENTUAL'"
            class="color-green text-thirteen"
          >
            MEDICAMENTO EVENTUAL
          </h6>
          <p
            v-if="
              medicine.frequency != 'EVENTUAL' &&
              medicine.medicine_amount_of_times_name
            "
            class="legends worksansr mb-0 check-text-center"
          >
            {{ medicine.medicine_amount_of_times_name }}
          </p>
          <div
            class="row m-0"
            v-if="medicine.medicine_amount_of_times_type == 'SHIFTS'"
          >
            <small class="col-md-6 p-0">TURNO</small>
            <small class="col-md-6 p-0">QUANTIDADE</small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.dawn && medicine.dawn_quantity"
            >
              MADRUGADA
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.dawn && medicine.dawn_quantity"
            >
              {{
                medicine.drops_dawn_quantity
                  ? `${medicine.drops_dawn_quantity} GOTA(S)`
                  : medicine.ui_dawn_quantity
                  ? `${medicine.ui_dawn_quantity} UI`
                  : medicine.dawn_quantity
              }}
              {{
                medicine.drops_dawn_quantity
                  ? ""
                  : medicine.ui_dawn_quantity
                  ? ""
                  : `${medicine.unit_of_measurement_abbreviation} (S)`
              }}
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.morning && medicine.morning_quantity"
            >
              MANHÃ
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.morning && medicine.morning_quantity"
            >
              {{
                medicine.drops_morning_quantity
                  ? `${medicine.drops_morning_quantity} GOTA(S)`
                  : medicine.ui_morning_quantity
                  ? `${medicine.ui_morning_quantity} UI`
                  : medicine.morning_quantity
              }}
              {{
                medicine.drops_morning_quantity
                  ? ""
                  : medicine.ui_morning_quantity
                  ? ""
                  : `${medicine.unit_of_measurement_abbreviation} (S)`
              }}
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.afternoon && medicine.afternoon_quantity"
            >
              TARDE
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.afternoon && medicine.afternoon_quantity"
            >
              {{
                medicine.drops_afternoon_quantity
                  ? `${medicine.drops_afternoon_quantity} GOTA(S)`
                  : medicine.ui_afternoon_quantity
                  ? `${medicine.ui_afternoon_quantity} UI`
                  : medicine.afternoon_quantity
              }}
              {{
                medicine.drops_afternoon_quantity
                  ? ""
                  : medicine.ui_afternoon_quantity
                  ? ""
                  : `${medicine.unit_of_measurement_abbreviation} (S)`
              }}
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.night && medicine.night_quantity"
            >
              NOITE
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.night && medicine.night_quantity"
            >
              {{
                medicine.drops_night_quantity
                  ? `${medicine.drops_night_quantity} GOTA(S)`
                  : medicine.ui_night_quantity
                  ? `${medicine.ui_night_quantity} UI`
                  : medicine.night_quantity
              }}
              {{
                medicine.drops_night_quantity
                  ? ""
                  : medicine.ui_night_quantity
                  ? ""
                  : `${medicine.unit_of_measurement_abbreviation} (S)`
              }}
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.shift_5 && medicine.shift_5_quantity"
            >
              5º
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.shift_5 && medicine.shift_5_quantity"
            >
              {{
                medicine.drops_shift_5_quantity
                  ? `${medicine.drops_shift_5_quantity} GOTA(S)`
                  : medicine.ui_shift_5_quantity
                  ? `${medicine.ui_shift_5_quantity} UI`
                  : medicine.shift_5_quantity
              }}
              {{
                medicine.drops_shift_5_quantity
                  ? ""
                  : medicine.ui_shift_5_quantity
                  ? ""
                  : `${medicine.unit_of_measurement_abbreviation} (S)`
              }}
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.shift_6 && medicine.shift_6_quantity"
            >
              6º
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.shift_6 && medicine.shift_6_quantity"
            >
              {{
                medicine.drops_shift_6_quantity
                  ? `${medicine.drops_shift_6_quantity} GOTA(S)`
                  : medicine.ui_shift_6_quantity
                  ? `${medicine.ui_shift_6_quantity} UI`
                  : medicine.shift_6_quantity
              }}
              {{
                medicine.drops_shift_6_quantity
                  ? ""
                  : medicine.ui_shift_6_quantity
                  ? ""
                  : `${medicine.unit_of_measurement_abbreviation} (S)`
              }}
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.shift_7 && medicine.shift_7_quantity"
            >
              7º
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.shift_7 && medicine.shift_7_quantity"
            >
              {{
                medicine.drops_shift_7_quantity
                  ? `${medicine.drops_shift_7_quantity} GOTA(S)`
                  : medicine.ui_shift_7_quantity
                  ? `${medicine.ui_shift_7_quantity} UI`
                  : medicine.shift_7_quantity
              }}
              {{
                medicine.drops_shift_7_quantity
                  ? ""
                  : medicine.ui_shift_7_quantity
                  ? ""
                  : `${medicine.unit_of_measurement_abbreviation} (S)`
              }}
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.shift_8 && medicine.shift_8_quantity"
            >
              8º
            </small>
            <small
              class="col-md-6 p-0"
              v-if="medicine.shift_8 && medicine.shift_8_quantity"
            >
              {{
                medicine.drops_shift_8_quantity
                  ? `${medicine.drops_shift_8_quantity} GOTA(S)`
                  : medicine.ui_shift_8_quantity
                  ? `${medicine.ui_shift_8_quantity} UI`
                  : medicine.shift_8_quantity
              }}
              {{
                medicine.drops_shift_8_quantity
                  ? ""
                  : medicine.ui_shift_8_quantity
                  ? ""
                  : `${medicine.unit_of_measurement_abbreviation} (S)`
              }}
            </small>
          </div>
          <p
            v-if="
              medicine.medicine_amount_of_times_type == 'DAY' ||
              medicine.frequency == 'EVENTUAL'
            "
            class="legends worksansr mb-0 check-text-center"
          >
            {{
              medicine.drops_quantity
                ? `${medicine.drops_quantity} GOTA(S)`
                : medicine.ui_quantity
                ? `${medicine.ui_quantity} UI`
                : medicine.quantity
            }}
            {{
              medicine.drops_quantity
                ? ""
                : medicine.ui_quantity
                ? ""
                : `${medicine.unit_of_measurement_name} (S)`
            }}
          </p>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pt-0 pb-0">
          <div v-for="(stock, index) in medicine.stocks" :key="index">
            <p class="m-0 legends worksansr mb-0 check-text-center">
              ESTOQUE:
              {{ stock.stock_name }}
            </p>
            <p class="m-0 legends check-text-center">
              TOTAL:
              {{ stock.total }}
              {{ medicine.unit_of_measurement_abbreviation }}
            </p>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pt-0 pb-0">
          <p
            class="m-0 legends worksansr check-text-center"
            v-if="expected_end_date"
          >
            DATA PREVISTA PARA ACABAR:
            {{ formatDate(medicine.expected_end_date, false) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../../lib/format";

export default {
  name: "Medicine",
  props: {
    title: String,
    medicines: Array,
    expected_end_date: [String, Boolean],
  },

  methods: {
    formatDate,
    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },
    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },
  },
};
</script>
